import classNames from 'classnames/bind';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { areaCode } from './utils';

const cx = classNames.bind(styles);

const SelectAgentBar = () => {
  const agentBar = useRef<HTMLDivElement | null>(null);
  const [isShowAgentBar, setShowAgentBar] = useState(false);
  const checkScroll = () => {
    const screenHeight: number = window.screen.height;
    const barY: number = agentBar.current?.offsetTop || 0;
    const barHeight: number = agentBar.current?.offsetHeight || 0;
    if (barY + barHeight > screenHeight + window.scrollY) {
      setShowAgentBar(true);
    } else {
      setShowAgentBar(false);
    }
  };

  const moveToAgentBar = () => {
    window.scrollTo(0, agentBar.current?.offsetTop || 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScroll);
    return () => {
      window.removeEventListener('scroll', checkScroll);
    };
  }, []);

  return (
    <div className={cx('SelectAgentBar')} ref={agentBar}>
      <div className={cx('inner')}>
        <h3 className={cx('title')}>판매사 선택하기</h3>
        {isShowAgentBar && (
          <button
            className={cx('jump_to_agents')}
            type="button"
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.otalist`}
            onClick={moveToAgentBar}
          >
            판매사 선택하기
          </button>
        )}
      </div>
    </div>
  );
};

export default SelectAgentBar;
